// ============================================================================
// view.animalHistory — the whole page, route-resource owned
// ============================================================================
// AnimalHistoryPage owned the ruminant half already: active cattle, active
// sheep, and both transfer ledgers, through animal.history.core. The other
// three species arrived from App's cold boot through four provider hooks, and
// they are what this declaration is about. They now have route-local owners:
//
//   animal.history.planner          the ppp-v4 / ppp-feeders-v1 /
//                                   ppp-breeders-v1 blobs, in one keyed read,
//                                   with App's in-memory projections
//                                   reproduced and none of its writes.
//   animal.history.layerDirectory   layer_batches + layer_housings, in App's
//                                   boot orderings.
//   animal.history.dailys           the three COMPLETE daily-report histories
//                                   (layer, poultry, pig). Nothing bounded
//                                   reproduces them: every month end back to
//                                   2024-10 resolves against the latest report
//                                   on or before that date.
//
// The matching retirements — `animalHistory` from all five frozen former-eager
// consumer lists — are declared in
// tests/fixtures/former-eager-dependencies.json, and the derivation in
// tests/static/former_eager_evidence_static.test.js will contradict them if any
// provider read comes back to this page's import closure.
//
// WHY residualLegacy IS EMPTY.
//
// There is no global data gate to declare. This page's content, loading state,
// error notice, and Retry are derived from its own four resources and nothing
// else. The declaration is therefore complete data-owner proof for the
// ledgered released route.
//
// Header is shared chrome with independently owned reads, so it is not a route
// residual here.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.animalHistory',
  obligations: Object.freeze([
    Object.freeze({id: 'animal.history.core', owner: 'permanent'}),
    Object.freeze({id: 'animal.history.planner', owner: 'permanent'}),
    Object.freeze({id: 'animal.history.layerDirectory', owner: 'permanent'}),
    Object.freeze({id: 'animal.history.dailys', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
